import { create } from 'zustand';
import axios from 'axios';
import { useAuthStore } from './authStore';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getUserId() {
  return useAuthStore.getState().user?.id || 'default';
}

export const useViewStore = create((set, get) => ({
  currentView: null,
  viewHistory: [],
  viewChanges: [],
  loading: false,
  generating: false,
  error: null,

  fetchViewHistory: async (isin) => {
    set({ loading: true, error: null });
    try {
      const { data } = await axios.get(`${API}/views/${isin}`, {
        params: { user_id: getUserId(), limit: 10 },
      });
      const views = Array.isArray(data) ? data : [];
      set({
        viewHistory: views,
        currentView: views.length > 0 ? views[0] : null,
        loading: false,
      });
    } catch (e) {
      set({ error: e.message, loading: false });
    }
  },

  generateView: async (isin) => {
    set({ generating: true, error: null });
    try {
      const { data } = await axios.post(`${API}/views/generate`, null, {
        params: { user_id: getUserId(), isin },
      });
      set(s => ({
        currentView: data,
        viewHistory: [data, ...s.viewHistory],
        generating: false,
      }));
      return data;
    } catch (e) {
      set({ generating: false, error: e.message });
      throw e;
    }
  },

  fetchViewChanges: async (days = 7) => {
    try {
      const { data } = await axios.get(`${API}/views/changes`, {
        params: { user_id: getUserId(), days },
      });
      set({ viewChanges: Array.isArray(data) ? data : [] });
    } catch {
      set({ viewChanges: [] });
    }
  },

  clearViews: () => set({ currentView: null, viewHistory: [], viewChanges: [] }),
}));
